export const fetchProfileListQuery = `
 query fetchProfileListQuery ($schemaId: ID!, $limit:Int, $offset:Int){
    structuredDataObjects(
      schemaId: $schemaId, 
      limit: $limit, 
      offset: $offset) {
      count
      records {
        id
        createdDateTime
        data
      }
    }
  }
`;

export const deleteSettingsProfileQuery = `
  mutation deleteSdo ($profileId: ID!, $schemaId: ID!) {
    deleteStructuredData(input: {
      id: $profileId
      schemaId: $schemaId
    }) {
      id
    }
  }
`;

export const updateSettingsProfileQuery = `
  mutation updateSettingProfile($profileId: ID!, $data: JSONData!, $schemaId: ID!) {
    createStructuredData(input: {
      id: $profileId,     
      data: $data
      schemaId: $schemaId,
    }) {
      id
      data
      createdDateTime
      modifiedDateTime
    }
  }
`;

export const createSettingsProfileQuery = `
  mutation createSettingsProfile($data: JSONData!, $schemaId: ID!) {
    createStructuredData(input: {
      data: $data
      schemaId: $schemaId,
    }) {
      id
      data
      createdDateTime
      modifiedDateTime
    }
  }
`;
